// extracted by mini-css-extract-plugin
export default {"drawerPaper":"styles_drawerPaper__fzBFC","dragHandle":"styles_dragHandle__y8wAd","drawerContent":"styles_drawerContent__g-nrG"};